// Import all JS assets
import { Adobe } from './adobe.js';

export function initAdobe() {
  HitchhikerJS.adobeManager = new Adobe(HitchhikerJS.isStaging);
  HitchhikerJS.adobeManager.addScripts();
}